import React from 'react'
import Titulo from './comum/Titulo';

export default class PainelUsuarioBloqueado extends React.Component {
  render () {
    return (
        <div>
          <div className="row internas">
            <div className='col-12 conteudo-internas conteudo-painel area-btn-filtro-painel'>
              <Titulo texto="Pagina inicial" urlRetorno="/gestao-empresa"/>
              <div className='col-12'>
                <div className="alert alert-warning text-center" role="alert">
                  <strong><h4>Existem pendêcias para seu usuário, por favor entrar em contato com suporte da empresa.</h4>
                    <br/>
                    <br/>
                  </strong>
                </div>
              </div>
            </div>
          </div>
        </div>
    )
  }
}
